// hooks/useApplyFilters.js
import { useCallback } from 'react';
import { API_CONSTANTS } from '../utils/constants';
import { createSearchParams } from '../utils/helpers';

export const useApplyFilters = ({
    filters,
    updateFilters,
    fetchSemanticRCA,
    fetchSemanticRCA2,
    fetchSpatialData,
    fetchAllCompanyDetails,
    UserData,
    fetchCategories,
    // fetchCategoryWithCount,
    saveToHistory,
    totalCounts,
    setTotalCounts,
    stateData,
    companyData,
    setIsLoading
}) => {
    const handleApplyFilters = useCallback(async () => {
        setIsLoading(true);
        try {
            const query = filters.query || API_CONSTANTS.DEFAULT_PROMPT;
            const data = await fetchSemanticRCA2({
                ...filters,
                query
            });

            let categoryData = [];
            categoryData = [
                query,
                {
                    prompt: query,
                    count: data.total_counts,
                    complaintNumbers: data?.complaintNumbers
                }
            ]

            setTotalCounts(categoryData[1].count);

            const newFilters = {
                ...filters,
                query,
                title: query,
                complaintNumbers: data?.complaintNumbers
            };

            UserData(data?.complaintNumbers);
            updateFilters({
                complaintNumbers: data?.complaintNumbers,
                // refreshTrigger: Date.now() // Force refresh in UserDataTable
            });
            await fetchCategories(categoryData, newFilters);

            const searchParams = {
                ...createSearchParams({ ...filters, query, title: query }),
                complaint_numbers: data?.complaintNumbers
            };
            searchParams.total_counts = categoryData[1].count;
            searchParams.prompt = query;
            saveToHistory(searchParams);
        } finally {
            setIsLoading(false);
        }
    }, [
        filters,
        updateFilters,
        fetchSemanticRCA,
        UserData,
        fetchCategories,
        saveToHistory,
        totalCounts,
        setIsLoading,
        fetchSemanticRCA2,
    ]);

    return { handleApplyFilters };
};